var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1382 17.5H3.70911V4.66667H11.7788L12.9996 3.5H3.70911C3.38532 3.5 3.0748 3.62292 2.84585 3.84171C2.6169 4.0605 2.48828 4.35725 2.48828 4.66667V17.5C2.48828 17.8094 2.6169 18.1062 2.84585 18.325C3.0748 18.5438 3.38532 18.6667 3.70911 18.6667H17.1382C17.462 18.6667 17.7725 18.5438 18.0015 18.325C18.2304 18.1062 18.359 17.8094 18.359 17.5V8.75L17.1382 9.91667V17.5Z",
    fill: "#AEB7C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5148 3.40686L18.4577 1.44102C18.3664 1.35354 18.2579 1.28413 18.1385 1.23678C18.0191 1.18942 17.8911 1.16504 17.7618 1.16504C17.6325 1.16504 17.5045 1.18942 17.3851 1.23678C17.2657 1.28413 17.1572 1.35354 17.0659 1.44102L8.69717 9.48519L8.01961 12.291C7.99074 12.427 7.99378 12.5675 8.0285 12.7022C8.06321 12.837 8.12875 12.9627 8.22039 13.0704C8.31203 13.178 8.4275 13.2649 8.55849 13.3248C8.68948 13.3847 8.83274 13.4162 8.97796 13.4169C9.05302 13.4248 9.12875 13.4248 9.20381 13.4169L12.1643 12.7927L20.5148 4.73686C20.6063 4.64961 20.6789 4.54597 20.7285 4.43185C20.7781 4.31774 20.8036 4.19541 20.8036 4.07186C20.8036 3.94831 20.7781 3.82597 20.7285 3.71186C20.6789 3.59775 20.6063 3.4941 20.5148 3.40686ZM11.5295 11.7135L9.29537 12.186L9.81423 10.0685L16.1137 4.00769L17.8351 5.65269L11.5295 11.7135ZM18.5248 4.99352L16.8035 3.34852L17.7496 2.42686L19.4832 4.08352L18.5248 4.99352Z",
    fill: "#AEB7C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.65d7fe959ab376b00cd2567a696aef0c.svg";
export { ForwardRef as ReactComponent };